import { Estado } from "../estado";
import { StateStorage } from "./state-storage";

class SessionStorage implements StateStorage {
    carregarEstado<EstateImpl extends Estado>(id:string) : EstateImpl | undefined {
        const estadoString = sessionStorage.getItem(id) as string;
        return <EstateImpl> JSON.parse(estadoString);
    }
    
    salvarEstado<EstateImpl extends Estado>(id: string, estado: EstateImpl): void {
        const estadoString = JSON.stringify(estado);
        sessionStorage.setItem(id, estadoString);
    }
}

const sesStorage = new SessionStorage();
export default sesStorage;